import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(private alertController: AlertController) {}

  async showAlert(
    title: string,
    message: string,
    confirmHandler: (data?: any) => void,
    data?: string
  ) {
    const alert = await this.alertController.create({
      cssClass: 'custom-alert',
      header: title,
      message: message,
      buttons: [
        {
          text: 'CANCELAR',
          role: 'cancel',
          cssClass: 'alert-button-cancel',
        },
        {
          text: 'CONFIRMAR',
          cssClass: 'alert-button-confirm',
          handler: () => {
            if (data) {
              confirmHandler(data);
            } else {
              confirmHandler();
            }
          },
        },
      ],
    });

    await alert.present();
  }
}
